<template>
  <div class="login-page page-container">
    <div class="login-dialog">
      <div class="dialog-title">手机注册/登录</div>
      <div class="inputs-bl">
        <div class="input-wrap">
          <input
            type="text"
            placeholder="请输入手机号码"
            v-model="form.phone"
            @keyup="onInput($event, 'phone')"
            @afterpaste="onInput($event, 'phone')"
            maxlength="11"
          />
          <span class="captcha_btn" :class="{ disabled: disabledBtn }" @click="sendCaptcha">
            {{ captchaSeconds > 0 ? `${captchaSeconds}秒` : '获取验证码' }}
          </span>
        </div>
        <div class="input-wrap">
          <input type="password" placeholder="请输入验证码" v-model="form.captcha" @input="onInput($event, 'captcha')" />
        </div>
      </div>
      <!-- <div class="dialog-title">快捷登录</div>
      <div class="quick-login-bl">
        <div class="quick-btn" v-for="btn in quickLoginBtns" :key="btn.key" @click="thirdPartyLogin(btn.key)">
          <i class="iconfont" :class="btn.icon"></i>
        </div>
      </div>
      <div class="tips">{{ tips }}</div> -->
      <div class="tips">目前只支持使用大陆手机号注册/登录</div>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';
import configFields from '@/utils/configFields';
const { DEFAULT_NATION_CODE } = configFields;
export default {
  name: 'Login',
  data() {
    return {
      quickLoginBtns: [
        { icon: 'iconwechat', key: 'weixin' },
        { icon: 'iconqq', key: 'qq' },
        { icon: 'iconsina', key: 'weibo' },
      ],
      tips: '非大陆手机用户请先使用第三方登录',
      form: {
        phone: '',
        captcha: '',
      },
      captchaSeconds: 0, // 验证码倒计时
	  ts: +new Date(),
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevPage = {
        path: from.path,
        query: from.query,
        params: from.params,
      };
      localStorage.loginPrevPage = JSON.stringify(vm.prevPage);
    });
  },
  activated() {
    Object.assign(this.$data, this.$options.data());
    this.initScrollTop();
  },
  beforeDestroy() {
    clearTimeout(this.captchaTimer);
  },
  computed: {
    disabledBtn() {
      return this.captchaSeconds > 0 || !this.checkPhone();
    },
  },
  methods: {
    onInput(e, key) {
      if (key === 'phone') {
        this.form[key] = e.target.value.replace(/[^\d]/g, '');
      } else {
        this.form[key] = e.target.value;
      }
      if (this.checkPhone() && this.checkCaptcha()) {
        this.login();
      }
    },
    checkPhone() {
      return this.form.phone.length === 11 && /^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(this.form.phone);
    },
    checkCaptcha() {
      return this.form.captcha && this.form.captcha.length === 4;
    },
    sendCaptcha() {
      if (!this.disabledBtn) {
        this.captchaSeconds = 60;
        this.startCaptchaTimer();
		var md5 = this.$md5(this.ts + '64!0j1ydr(5+0^o7')
        requestApi(
          '/v3/api/v1/send/vcode/',
          {
            mobile: this.form.phone,
            nation_code: DEFAULT_NATION_CODE + '',
          },
          'POST',
		  {
			  ts:this.ts,
			  signature: md5,
		  },
        );
      }
    },
    login() {
      requestApi(
        '/v3/api/v1/login/',
        {
          user_name: this.form.phone,
          v_code: this.form.captcha,
          nation_code: DEFAULT_NATION_CODE,
        },
        'POST'
      ).then(({ user, token }) => {
        this.$store.commit('setUser', user);
        this.$store.commit('setToken', token);
        this.$store.dispatch('getVipInfo');
        localStorage.removeItem('loginPrevPage');
        this.$router.replace(this.prevPage || '/home');
      });
    },
    /**
     * @description: 三方登录
     */
    thirdPartyLogin(type) {
      window.location.href = `${process.env.VUE_APP_URL}/api/site/login/other/?type=${type}`;
    },
    /**
     * @description: 开启定时器
     */
    startCaptchaTimer() {
      if (this.captchaTimer) {
        clearTimeout(this.captchaTimer);
      }
      this.captchaTimer = setTimeout(() => {
        this.captchaTimer = null;
        this.captchaSeconds -= 1;
        if (this.captchaSeconds < 10) {
          this.captchaSeconds = `0${this.captchaSeconds}`;
        }
        if (this.captchaSeconds > 0) {
          this.startCaptchaTimer();
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  height: calc(100vh - 160px);
  min-height: 600px;
  background: url('../assets/imgs/login-bg.jpg') no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  .login-dialog {
    background: $C1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    width: 400px;
    .inputs-bl {
      margin-bottom: 40px;
      .input-wrap {
        color: $C3;
        height: 40px;
        border: 1px solid $A6;
        width: 100%;
        display: flex;
        align-items: center;
        background: $C1;
        margin-bottom: 20px;
        input {
          font-size: 16px;
          border: none;
          outline: none;
          height: 100%;
          flex: 1;
          padding: 0 0 0 10px;
        }
      }
      .captcha_btn {
        width: 20%;
        background: $C2;
        color: $C1;
        font-size: 12px;
        line-height: 36px;
        margin-right: 2px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease-in;
        &.disabled {
          background: $C10;
          color: $C13;
          cursor: default;
        }
      }
    }
    .tips {
      text-align: center;
      font-size: 10px;
      color: $C13;
    }
    .quick-login-bl {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin: 40px;
      .iconfont {
        font-size: 33px;
        cursor: pointer;
        color: $C3;
      }
    }
  }
  .dialog-title {
    font-family: HYXinRenWenSongW;
    font-size: 18px;
    color: $C3;
    margin-bottom: 20px;
  }
}
</style>
